// Adds a BreadcrumbList JSON-LD block for the current route. Call once per page.
//
// The trail is built from the route path, NOT story.full_slug: several dedicated pages
// (/pipeline-services, /news, ...) are backed by stories whose full_slug differs from the
// public URL (e.g. "pipeline-services/pipeline-services", "news-index").
export function useBreadcrumbSchema(title?: string) {
  const route = useRoute()

  const slug = route.path
    .replace(/^\/th(?=\/|$)/, '')
    .replace(/^\/+|\/+$/g, '')

  // The homepage has no trail worth marking up.
  if (!slug)
    return

  const trail = breadcrumbTrail(slug, title?.split('|')[0].trim())

  useHead({
    script: [{
      type: 'application/ld+json',
      innerHTML: JSON.stringify(breadcrumbListSchema(trail, `https://www.dexon-technology.com/${slug}`)),
    }],
  })
}
